import { keyPressWrapper } from '../../../bookings/util/useKeyboard';
import {
  TrackingDataEvent,
  TrackingDataLocation,
} from '../../../common/AnalyticsContext/LinkTracking';
import { renderLinkTrackingAttributes } from '../../../common/AnalyticsContext/renderLinkTrackingAttributes';
import { useHomepageTiles } from '../../../common/Experiments/HomepageTilesExperiment';
import { SearchPromotionItem } from '../../../common/components/SearchHeader/Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';
import {
  StyledSpecialtyButton,
  SpecialtyIcon,
  SpecialtyIconWrapper,
  Badge,
} from './SearchSpecialtySelector.styles';
import { SpecialtyLabelSwitcher } from './SpecialtyLabelSwitcher';

interface SpecialtyButtonProps extends SearchPromotionItem {
  setActive: () => void;
  active: boolean;
}

export const SpecialtyButton = ({
  setActive,
  title,
  altTitle,
  active,
  icon,
  badge,
}: SpecialtyButtonProps) => {
  const homepageTilesExperiment = useHomepageTiles();

  return (
    <StyledSpecialtyButton
      onClick={setActive}
      onKeyPress={e => keyPressWrapper(e.key, setActive)}
      tabIndex={0}
      active={active}
      experiment={homepageTilesExperiment}
      role="button"
      {...renderLinkTrackingAttributes({
        event: TrackingDataEvent.SEARCH_BOX_SELECTOR_OPTION_CLICK,
        location: TrackingDataLocation.HOMEPAGE_HERO,
        specialty: title === 'GP Telehealth' ? 'General Practice Telehealth' : title,
      })}
    >
      {icon && (
        <SpecialtyIconWrapper experiment={homepageTilesExperiment}>
          <SpecialtyIcon
            src={icon}
            height={35}
            htmlAttributes={{ alt: title }}
            experiment={homepageTilesExperiment}
          />
        </SpecialtyIconWrapper>
      )}
      <SpecialtyLabelSwitcher desktopLabel={title} mobileLabel={altTitle} />
      {badge && (
        <Badge>
          <div>{badge}</div>
        </Badge>
      )}
    </StyledSpecialtyButton>
  );
};
